<template>
  <div id="container-area" class="web-builder-container">
    <!-- Debug Info Area -->
    <div v-if="false" class="debug-info">
      <h4>Debug Info</h4>
      <p><strong>Mouse Position:</strong> X: {{ mouse_pos.x }}, Y: {{ mouse_pos.y }} ({{ mouse_button_state }})</p>
      <p><strong>Dragging Component:</strong> {{ dragged_tool_button_item ? dragged_tool_button_item.type : 'None' }}</p>
      <p><strong>Components Array:</strong> {{ components.length }} components</p>
      <p><strong>Tool drag position:</strong> {{ dragged_tool_button_style }} </p>
    </div>

    <!-- This is the button being dragged and dropped over the view -->
    <!-- Todo: make sure the button follows the mouse position -->
    <WebBuilderToolButton
      v-if="dragged_tool_button_item"
      :item="dragged_tool_button_item"
      :style="dragged_tool_button_style"
      class="dragging"
    />

    <div class="web-builder-row">
      <!-- The Container's main area where components are rendered -->
      <div ref="web-builder-main" id="web-builder-main" class="web-builder-main">
        <div class="drop-area" :style="{ maxWidth: max_width, position: 'relative' }" @mousemove="on_mouse_move">
          <WebBuilderLayoutRow
            class="layout-row mt-4"
            v-for="(row, index) in rows"
            :show_placeholder="show_placeholder"
            :index="index" 
            :item="row" 
            :key="index"
            @on_mouse_up="mouseup_row"
            @header_update="row_header_update"
            @option_update="row_option_update"
            @add_option="add_option_on_row"
            @copy_row="copy_row"
            >
          </WebBuilderLayoutRow>
        
        </div>
      </div>

      <!-- The Toolbar inside the Container -->
      <div class="web-builder-toolbar">
        <WebBuilderToolbar @start-drag="start_drag" />
      </div>
    </div>
  </div>
</template>

<script>
import WebBuilderToolbar from '@/view/components/web_builder/WebBuilderToolbar.vue';
import WebBuilderLayoutRow from '@/view/components/web_builder/render_components/WebBuilderLayoutRow.vue';
import WebBuilderSimpleComponent from '@/view/components/web_builder/render_components/WebBuilderSimpleComponent.vue';
import WebBuilderSurveyRadio from '@/view/components/web_builder/render_components/WebBuilderSurveyRadio.vue';
import WebBuilderSurveyCheckbox from '@/view/components/web_builder/render_components/WebBuilderSurveyCheckbox.vue';
import WebBuilderSurveyMatrix from '@/view/components/web_builder/render_components/WebBuilderSurveyMatrix.vue';
import WebBuilderSurveySlider from '@/view/components/web_builder/render_components/WebBuilderSurveySlider.vue';
import WebBuilderToolButton from '@/view/components/web_builder/WebBuilderToolButton.vue';

export default {
  name: 'WebBuilderContainer',
  components: {
    WebBuilderToolbar,
    WebBuilderLayoutRow,
    WebBuilderSimpleComponent,
    WebBuilderSurveyRadio,
    WebBuilderToolButton,
    WebBuilderSurveyCheckbox,
    WebBuilderSurveyMatrix,
    WebBuilderSurveySlider,
  },
  emits: ['updated'],
  props: {
    max_width: {
      type: String,
      default: '800px',
    }
  },
  computed: {
    show_placeholder() {
      return this.dragged_tool_button_item !== null;
    },
    // Correct positioning of dragged button without any offsets
    dragged_tool_button_style() {
      return {
        position: 'absolute',
        top: `${this.mouse_pos.y - this.container_offset.y}px`,  // Correct position relative to the page
        left: `${this.mouse_pos.x - this.container_offset.x}px`,  // Correct position relative to the page
        zIndex: 9999,
        pointerEvents: 'none',  // Prevent interfering with other events
      };
    },
  },
  data() {
    return {
      debounce_timer: null,
      at_bottom: true,
      rows: [
        { index: 0, },
      ],

      dragged_tool_button_item: null,
      components: [],  // The array that holds all components in the container
      mouse_pos: { x: 0, y: 0 },  // Current mouse position
      mouse_button_state: 'none',
      container_offset: { x: 0, y: 0 },
    };
  },
  methods: {
    copy_row(index, item_row) {
      const i = JSON.parse(JSON.stringify(item_row));

      console.log('copy row', index, item_row);

      this.insert_item_at_index(i, index+1);
    },
    add_option_on_row(index, item_row) {
      this.rows[index].options.push({
        text: 'Nytt alternativ ' + (this.rows[index].options.length + 1),
        value: this.rows[index].options.length + 1
      });

      this.rows = [...this.rows];

      this.emit_update_with_debounce();
    },
    row_option_update(row_index, option_index, text) {
      this.rows[row_index].options[option_index].text = text;

      this.emit_update_with_debounce();
    },
    row_header_update(index, item, text) {
      this.rows[index].header = text;

      this.emit_update_with_debounce();
    },

    emit_update_with_debounce() {
      clearTimeout(this.debounce_timer);

      this.debounce_timer = setTimeout(async () => {
        console.log('emitting update');
        this.$emit('update', this.rows);
      }, 500); 
    },
    insert_item_at_index(item, index) {
      if (!item) {
        return;
      }

      if (this.rows.length === 0) {
        throw 'invalid number of rows';
      }

      if (this.rows.length === 1) {
        this.rows = [
          { index: 0, }, { index: 1, ...item }, { index: 2, },
        ];

        return;
      }

      this.rows[index] = { ...item, index: index }
      let new_index = index;

      if (index === 0) {
        // there is always a placeholder at 0
        this.rows.unshift({ index: 0 });
        new_index = 1;

        if (this.rows[2].type) {
          // only insert a placeholder if there is no placeholder after
          this.rows.splice(2, 0, { index: 0 });
        }
      }
      else if (index === this.rows.length-1) {
        if (this.rows[index-1].type) {
          // only insert a placeholder if there is no placeholder before
          this.rows.splice(index, 0, { index: 0 });
          new_index = index + 1;
        }
        /// always insert a placeholder at end
        this.rows.push({ index: this.rows.length });

        const div = document.getElementById('web-builder-main');
        div.scrollTo(0, 50000);
        
      }
      else {
        if (this.rows[index-1].type) {
          this.rows.splice(index, 0, { index: 0 });
          new_index = index + 1;
        }

        if (this.rows[new_index+1].type) {
          this.rows.splice(new_index+1, 0, { index: 0 });
        }
      }

      let i = 0;
      for (const row of this.rows) {
        row.index = i++;
      }

      this.rows = [ ...this.rows ];
      if (this.at_bottom) {
        
        this.$nextTick(()=>{
          const div = document.getElementById('web-builder-main');
          div.scrollTo(0, 50000);
        });
      }
    },
    mouseup_row(index) {
      this.insert_item_at_index(this.dragged_tool_button_item, index);
    },
    // Start the drag event by creating a new component in the container
    start_drag(item, event) {
      this.dragged_tool_button_item = item;
      const container = document.getElementById('container-area');  // Get the container element
      const container_rect = container.getBoundingClientRect();  // Get the container's position on the page
      this.container_offset = {
        x: container_rect.left,
        y: container_rect.top,
      };

      const div = document.getElementById('web-builder-main');
      this.at_bottom = div.scrollHeight - div.scrollTop === div.clientHeight;

      this.$nextTick(()=>{

        if (this.at_bottom) {
          div.scrollTo(0, 50000);
        }
        
      });
    },

    // Track mouse movement while dragging
    on_mouse_move(event) {
      if (this.dragged_tool_button_item) {
        this.mouse_pos = { x: event.clientX, y: event.clientY };
      }
    },

    on_mouse_up() {
      this.mouse_button_state = 'up';
      
      if (this.dragged_tool_button_item) {
        this.add_component_to_container(this.mouse_pos);  // Add component to container
        this.dragged_tool_button_item = null;  // Clear dragging component
      }
    },

    on_mouse_down() {
      this.mouse_button_state = 'down';
    },

    // Allow the drop to happen
    on_drag_over(index, event) {
      event.preventDefault();
      event.dataTransfer.dropEffect = 'move';  // Indicate the move effect
    },

    // Called when the component is dropped
    on_drop(index, event) {
      event.preventDefault();  // Prevent default action
      this.add_component_to_container(this.mouse_pos, index);  
      this.dragged_tool_button_item = null;  // Clear dragging item
    },

    // Add the component to the container at the specified index (or push if index is invalid)
    add_component_to_container(position, index = this.components.length) {
      const new_component = { type: this.dragged_tool_button_item.type, position };
      this.components.push(new_component);  // Push the new component into the array
    },

    // Basic style for each component in the container
    component_style(component) {
      return {
        position: 'relative',
      };
    }
  },
  mounted() {
    // Attach mouseup and mousemove events to document globally
    document.addEventListener('mouseup', this.on_mouse_up);
    document.addEventListener('mousedown', this.on_mouse_down);
    document.addEventListener('mousemove', this.on_mouse_move);
  },
  before_destroy() {
    // Clean up event listeners when the component is destroyed
    document.removeEventListener('mouseup', this.on_mouse_up);
    document.removeEventListener('mousedown', this.on_mouse_down);
    document.removeEventListener('mousemove', this.on_mouse_move);
  }
};
</script>

<style scoped>
#container-area {
  display: flex;
  flex-direction: column;
}

/* Debug Info Style */
.debug-info {
  background-color: #f8f9fa;
  padding: 15px;
  border-bottom: 2px solid #ddd;
  font-size: 14px;
  margin-bottom: 15px;
}

.debug-info h4 {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
}

.debug-info p {
  margin: 5px 0;
}

.debug-info pre {
  background: #eee;
  padding: 10px;
  font-size: 12px;
  max-width: 100%;
  word-wrap: break-word;
  white-space: pre-wrap;
}

/* Drop Area */
.drop-area {
  
  border: 1px dashed #ccc;
  margin: 10px 0;
  cursor: pointer;
}

/* Between Rows Drop Area */
.between-rows-drop-area {
  background-color: aqua;
  border: 1px solid dashed black;
}

/* Dragging Component Style */
.dragging-component {
  opacity: 0.5;
}

.outer-dropzone {
  border: 2px solid brown !important;
}

/* Remove focus styles while dragging */
:focus {
  outline: none !important;
}

.web-builder-row {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  min-height: 0;
}

.web-builder-main {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.web-builder-toolbar {
  width: 456px;
  flex-shrink: 0;
  padding-left: 16px;
  height: 100%;
  overflow: hidden;
}

.web-builder-container {
  height: 695px;
  display: flex;
  flex-direction: column;
}

.layout-row {
  max-width: 600px;
  margin: auto;
}

</style>
